import React, { useState, useEffect } from 'react';
import {
  Box, Grid, Typography, TextField, MenuItem, Button,
  Snackbar, Divider, Card, CardContent,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import MuiAlert from '@mui/material/Alert';
import dayjs from 'dayjs';
import { Assignment, LocationOn } from '@mui/icons-material';
import { useCarrito } from '../context/CarritoContext';
import Navbar from '../Navbar/Navbar';
import { useNavigate } from 'react-router-dom';

const CitaForm = () => {
  const navigate = useNavigate();
  const [fecha, setFecha] = useState(null);
  const [hora, setHora] = useState('');
  const [comentario, setComentario] = useState('');
  const [solicitado, setSolicitado] = useState('');
  const [tipoCita, setTipoCita] = useState('');
  const [estado, setEstado] = useState('');
  const [ubicacion, setUbicacion] = useState('');
  const [horasDisponibles, setHorasDisponibles] = useState([]);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const nombreUsuario = sessionStorage.getItem('Nombre');
  const Empresa = sessionStorage.getItem('Empresa');
  const Telefono = sessionStorage.getItem('Telefono');
  const { IdUsuario } = useCarrito();

  useEffect(() => {
    if (tipoCita === 'centro camionero') {
      setEstado('Aguascalientes');
      setUbicacion('');
    }
  }, [tipoCita]);

useEffect(() => {
  if (!fecha || !tipoCita || !estado) {
    setHorasDisponibles([]);
    return;
  }

  const dayOfWeek = dayjs(fecha).day();
  const isUnidadMovil = tipoCita === 'unidad movil';
  const isRecoleccion = tipoCita === 'recoleccion';

  if (dayOfWeek === 0 && tipoCita !== 'centro camionero') {
    setHorasDisponibles([]);
    return;
  }

  const inicio = (isUnidadMovil || isRecoleccion) && dayOfWeek === 0 ? 7 : 9;
  const fin = (isUnidadMovil || isRecoleccion) && dayOfWeek === 0 ? 19 : (dayOfWeek === 6 ? 14 : 19); 

  const now = dayjs();
  const isHoy = dayjs(fecha).isSame(now, 'day');
  const segundaHora = now.minute() > 0
    ? now.startOf('hour').add(2, 'hour')
    : now.startOf('hour').add(1, 'hour').add(1, 'hour');

  const slots = [];
  for (let h = inicio; h < fin; h++) {
    const hh = h.toString().padStart(2, '0');
    slots.push(`${hh}:00`);
    if (isUnidadMovil || isRecoleccion) {
      slots.push(`${hh}:30`);
    }
  }

  const validSlots = isHoy
    ? slots.filter((slot) => {
        const [h, m] = slot.split(':').map(Number);
        const slotTime = dayjs().hour(h).minute(m);
        return slotTime.isSame(segundaHora) || slotTime.isAfter(segundaHora);
      })
    : slots;

  const fechaFmt = dayjs(fecha).format('YYYY-MM-DD');

  fetch('https://bibliotecadlago.com/php/Backend/obtener_citas.php', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ fecha: fechaFmt, estado }),
  })
    .then((res) => res.json())
    .then((data) => {
      if (!Array.isArray(data)) {
        setHorasDisponibles(validSlots);
        return;
      }

      const conteo = {};
      data.forEach((cita) => {
        const horaFmt = cita.hora.slice(0, 5);
        const key = `${cita.tipo}-${cita.estado}-${horaFmt}`;
        conteo[key] = (conteo[key] || 0) + 1;
      });

      const disponibles = validSlots.filter((slot) => {
        const key = `${tipoCita}-${estado}-${slot}`;
        const cnt = conteo[key] || 0;

        if ((isUnidadMovil || isRecoleccion) && estado === 'Aguascalientes') {
          return cnt < 2;
        }

        return cnt < 1;
      });

      setHorasDisponibles(disponibles);
    })
    .catch(() => {
      setHorasDisponibles(validSlots);
    });
}, [fecha, tipoCita, estado]);




  const handleSubmit = (e) => {
    e.preventDefault();

    const finalEstado = tipoCita === 'centro camionero' ? 'Aguascalientes' : estado;
    const finalUbicacion =
      tipoCita === 'unidad movil' && ['Aguascalientes', 'Jalisco'].includes(estado)
        ? ubicacion
        : '';

    fetch('https://bibliotecadlago.com/php/Backend/registrar_cita.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        IdUsuario,
        Tipo: tipoCita,
        Fecha: dayjs(fecha).format('YYYY-MM-DD'),
        Hora: hora,
        Comentario: comentario,
        Estado: finalEstado,
        Ubicacion: finalUbicacion,
        Solicitado: solicitado,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          showNotification('✅ Cita registrada correctamente.', 'success');
          setFecha(null);
          setHora('');
          setComentario('');
          setTipoCita('');
          setEstado('');
          setUbicacion('');
          navigate('/servicios');
        } else {
          showNotification('❌ ' + data.message, 'error');
        }
      })
      .catch(() => {
        showNotification('❌ Error en el servidor.', 'error');
      });
  };

  const showNotification = (message, severity = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setOpenSnackbar(true);
  };

  return (
    <>
      <Navbar />

      <Box sx={{ maxWidth: 700, mx: 'auto', p: 3 }}>
        <Card elevation={3}>
          <CardContent>
            <Typography variant="h4" align="center" gutterBottom>
              📅 Generar Cita
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography><strong>Nombre:</strong></Typography>
                <Typography>{nombreUsuario}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography><strong>Empresa:</strong></Typography>
                <Typography>{Empresa}</Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography><strong>Teléfono:</strong></Typography>
                <Typography>{Telefono}</Typography>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField
                label="Solitado por:"
                multiline
                rows={1}
                value={solicitado}
                onChange={(e) => setSolicitado(e.target.value)}
                fullWidth
              />
              <TextField
                select
                label="Tipo de Cita"
                value={tipoCita}
                onChange={(e) => setTipoCita(e.target.value)}
                fullWidth
              >
                <MenuItem value="unidad movil">Unidad Móvil</MenuItem>
                <MenuItem value="centro camionero">Centro Camionero</MenuItem>
                {/*
                  <MenuItem value="recoleccion">Recolección</MenuItem>
                */}
              </TextField>

              {tipoCita !== 'centro camionero' && (
                <TextField
                  select
                  label="Estado"
                  value={estado}
                  onChange={(e) => setEstado(e.target.value)}
                  fullWidth
                >
                  <MenuItem value="Aguascalientes">Aguascalientes</MenuItem>
                  <MenuItem value="Jalisco">Jalisco</MenuItem>
                  {tipoCita === 'unidad movil' && (
                    <MenuItem value="Zacatecas">Zacatecas</MenuItem>
                  )} 
                </TextField>
              )}

              {(tipoCita === 'unidad movil'|| tipoCita === 'recoleccion' ) && ['Aguascalientes', 'Jalisco'].includes(estado) && (
                <TextField
                  label="Ubicación"
                  value={ubicacion}
                  onChange={(e) => setUbicacion(e.target.value)}
                  multiline
                  fullWidth
                  rows={2}
                  InputProps={{
                    startAdornment: <LocationOn sx={{ mr: 1 }} />,
                  }}
                />
              )}

              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <DatePicker
                    label="Fecha"
                    value={fecha}
                    onChange={(newVal) => setFecha(newVal)}
                    disablePast
                    format="DD/MM/YYYY"
                    sx={{ width: '100%' }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    select
                    label="Hora"
                    value={hora}
                    onChange={(e) => setHora(e.target.value)}
                    disabled={!horasDisponibles.length}
                    sx={{ width: '150px' }}
                  >
                    {horasDisponibles.map((h) => (
                      <MenuItem key={h} value={h}>
                        {h}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>

              <TextField
                label="Comentario"
                multiline
                rows={4}
                value={comentario}
                onChange={(e) => setComentario(e.target.value)}
                fullWidth
                InputProps={{
                  startAdornment: <Assignment sx={{ mr: 1 }} />,
                }}
              />

              <Box display="flex" justifyContent="center" mt={2}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!fecha || !hora}
                  sx={{ px: 5 }}
                >
                  Agendar Cita
                </Button>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          onClose={() => setOpenSnackbar(false)}
          severity={snackbarSeverity}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
};

export default CitaForm;
